// @flow
import { handleResponseOld, makePost } from './helpers';

type PostCodexLotsParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    itemIds: Array<number>,
};

export default {
    submitCodexLots: ({ authToken, bidderId, deployment, itemIds: lotIds }: PostCodexLotsParams) => {
        return new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'bidders',
                authToken,
                deployment,
                path: `<TITLE-API>/${bidderId}/lots`,
            });
            request.send({
                lotIds,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        });
    },
};
